import * as Yup from "yup";

const ChildStep2Schema = Yup.object().shape({
  hasBeenImmunised: Yup.boolean().required("Required"),
});

export default ChildStep2Schema;
